module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/cover"
    }
  }, [_vm._v("THE OMEGA COMMAND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Part_One"
    }
  }, [_vm._v("Part One: Madame Rosa’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/chap1"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/chap2"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/chap3"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/chap4"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/chap5"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/chap6"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Part_Two"
    }
  }, [_vm._v("Part Two: The Narcissus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/chap7"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/chap8"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/chap9"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/Part_Three",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: San Melas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/Part_Four",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four: Newport")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/Part_Five",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Five: Horse Neck Island")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/chap34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE ALPHA DECEPTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/partone#c01a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part One: Oblivion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch1#c01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch2#c02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch3#c03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch4#c04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch5#c05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch6#c06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch7#c07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch8#c08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch9#c09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/parttwo#c01b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two: Into the Labyrinth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch10#c010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch11#c011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch12#c012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch13#c013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch14#c014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch15#c015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch16#c016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch17#c017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch18#c018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch19#c019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/partthree#c01c",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: Rounding Up the Usual Suspects")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch20#c020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch21#c021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch22#c022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch23#c023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch24#c024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch25#c025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch26#c026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/partfour#c01d",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four: The Dragon Fish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch27#c027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch28#c028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch29#c029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch30#c030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/partfive#c01e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Five: The Battle of Pamosa Springs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch31#c031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch32#c032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch33#c033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch34#c034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ch35#c035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/epi#c036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/ack#c037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE GAMMA OPTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/p1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part One: Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/p2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two: Critical Mass")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/p3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: The Indianapolis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/p4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four: The O.K. Corral")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/p5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Five: Independence Day")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Comon/Preview",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preview: "), _c('i', [_vm._v("The Omicron Legion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Comon/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Biography of Jon Land")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc27d5a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bundle_content.vue
// module id = 72
// module chunks = 0